<template>
<div>
  <div 
    @click="toggleModal" 
    class="bg-white rounded-md inline-flex items-center overflow-hidden"
    :class="{ 'cursor-help': showInfoModalOnClick }"
    style="box-shadow: 0 0 0 2px #635BFF"
  >
    <span class="px-2 text-xs text-stripe font-semibold">
      Pay with
    </span>
    <span class="block px-1.5 py-0.5 bg-stripe">
      <StripeLogo class="h-5 text-white bg-stripe" />
    </span>
  </div>

  <Modal 
    v-if="showInfoModal" 
    @close="toggleModal"
  />
</div>
</template>

<script>
import Modal from './PayWithStripeInfoModal.vue'
import StripeLogo from './StripeLogo.vue'

export default {
  components: { 
    StripeLogo, 
    Modal,
  },
  props: {
    showInfoModalOnClick: {
      default: true
    }
  },
  data() {
    return {
      showInfoModal: false,
    }
  },
  methods: {
    toggleModal() {
      if (this.showInfoModalOnClick) {
        this.showInfoModal = !this.showInfoModal
      }
    }
  }
}
</script>
